import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr';
import userManager from '../services/SecurityService';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import mitt from 'mitt';

export const signalRHub = mitt();

export default {
    install (app, options) {
      app.config.globalProperties.$signalRHub = signalRHub;

      let connection = null;
      let startedPromise = null;
      let manuallyClosed = false;

     app.config.globalProperties.startSignalR = () => {
        userManager.getUser().then(async function (user) {
            if (startedPromise || !user || user.expired) return;

            connection = new HubConnectionBuilder()
            .withUrl(`${options.baseURL}clientNotificationHub`, { accessTokenFactory: () => user.access_token, transport: HttpTransportType.LongPolling })
            .configureLogging(LogLevel.None)
            .build();

            connection.on('updateSelectList', async (listName) => {
                // listName arrives as the legacy Vuex mutation name, e.g. "updateAccounts"
                listName = listName.split('update')[1];
                listName = listName.charAt(0).toLowerCase() + listName.slice(1);
                await selectListOptionsDataContext.refreshStoreDropdownData(listName);
            });

            connection.on('buyersGuideLoaded', (isLoading) => {
                signalRHub.emit('buyersGuideLoaded', isLoading);
            });

            async function trySilentReauth() {
                try {
                    user = await userManager.signinSilent();
                    await start();
                } catch (e) {
                    app.config.globalProperties.stopSignalR();
                }
            }

            function isForbiddenError(err) {
                return (
                    err &&
                    (err.status === 403 ||
                    err.message?.includes("403") ||
                    err.status === 404 ||
                    err.message?.includes("404") ||
                    err.message?.includes("Forbidden"))
                );
            }

            async function start() {
                try {
                    if(!user.expired)
                    {
                        startedPromise= await connection.start();
                    }
                } catch (err) {
                    if (isForbiddenError(err)) {
                        await trySilentReauth();
                    }
                }
            }

            connection.onclose(async () => {
                if(!manuallyClosed)
                    await start();
            });

            manuallyClosed = false;
            await start();
        });
      };

      app.config.globalProperties.stopSignalR = () => {
        if (!startedPromise) return;

        manuallyClosed = true;
        return startedPromise
            .then(() => connection.stop())
            .then(() => { startedPromise = null });
      };
    }
  };
